import React, { Fragment } from "react";

const Header = ({ titulo }) => {
  return (
    <Fragment>
      <h1>{titulo}</h1>
    </Fragment>
  );
};

export default Header;
